<div class="col-md-12 d-flex contact-heading">
  <p>Contact Us</p>
  <p>We are here to help!</p>
  <p>Complete the information below and we will get back to you soon.</p>
</div>
<div class="col-md-12 d-flex">
  <form [formGroup]="contactUsForm">
    <div class="form-group">
      <label for=""> Name *</label>
      <input type="text" class="form-control" formControlName="name"/>
    </div>
    <div class="form-group">
      <label for="">Company *</label>
      <input
        type="text"
        class="form-control"
        placeholder="Company"
        formControlName="company"
        maxlength="256"
        [class.valid]="contactUsForm.get('company').valid && submitted"
        [class.invalid]="contactUsForm.get('company').invalid && submitted"
        />
        @if (contactUsForm.get('company').invalid && submitted && contactUsForm.get('company').errors) {
          <div>
            @if (contactUsForm.get('company').hasError('required')) {
              <small class="text-danger">
                Company is required.
              </small>
            }
          </div>
        }
      </div>
      <div class="form-group">
        <label for="">Email address *</label>
        <input type="text" class="form-control" formControlName="emailId"/>
      </div>
      <div class="form-group">
        <label for="">Phone number {{ contactUsForm.value.contactPhone ? '*' : '' }}</label>
        <input
          type="text"
          id="tel"
          class="form-control"
          phoneMask
          [phoneControl]="contactUsForm.controls['phnNo']"
          [preValue]="contactUsForm.value.phnNo"
          placeholder="(XXX)-XXX-XXXX"
          maxlength="14"
          formControlName="phnNo"
          />
          @if (contactUsForm.get('phnNo').invalid && submitted && contactUsForm.get('phnNo').errors) {
            <div>
              @if (contactUsForm.get('phnNo').hasError('required')) {
                <small class="text-danger">
                  Phone number is required.
                </small>
              }
              @if (contactUsForm.get('phnNo').hasError('pattern')) {
                <small class="text-danger">
                  Please enter a valid phone number.
                </small>
              }
            </div>
          }
        </div>
        <div class="form-group">
          <label for="">Country *</label>
          <select
            class="form-control"
            formControlName="country"
            [class.valid]="contactUsForm.get('country').valid && submitted"
            [class.is-invalid]="contactUsForm.get('country').invalid && submitted"
            >
            <option value="" disabled="true" [selected]="true">Country</option>
            @for (country of objectKeys(countries); track country) {
              <option [value]="country">{{ countries[country] }}</option>
            }
          </select>
          @if (contactUsForm.get('country').invalid && submitted && contactUsForm.get('country').errors) {
            <div>
              @if (contactUsForm.get('country').hasError('required')) {
                <small class="text-danger">
                  Country is required.
                </small>
              }
            </div>
          }
        </div>
        <div class="form-group"></div>
        <div class="form-group">
          <label for="">State / Province *</label>
          <select
            class="form-control"
            formControlName="region"
            [class.valid]="contactUsForm.get('region').valid && submitted"
            [class.is-invalid]="contactUsForm.get('region').invalid && submitted"
            >
            <option value="" disabled="true" [selected]="true">State</option>
            @for (state of objectKeys(states).sort(); track state) {
              <option [value]="state">{{ states[state] }}</option>
            }
          </select>
          @if (contactUsForm.get('region').invalid && submitted && contactUsForm.get('region').errors) {
            <div>
              @if (contactUsForm.get('region').hasError('required')) {
                <small class="text-danger"> State is required. </small>
              }
            </div>
          }
        </div>
        <div class="form-group">
          <label for="">City *</label>
          <input
            type="text"
            class="form-control"
            placeholder="City"
            formControlName="city"
            maxlength="48"
            [class.valid]="contactUsForm.get('city').valid && submitted"
            [class.invalid]="contactUsForm.get('city').invalid && submitted"
            />
            @if (contactUsForm.get('city').invalid && submitted && contactUsForm.get('city').errors) {
              <div>
                @if (contactUsForm.get('city').hasError('required')) {
                  <small class="text-danger">
                    City is required.
                  </small>
                }
              </div>
            }
          </div>
          <div class="row col-md-4">
            <label for="">Select a Category *</label>
            <select
              class="form-control"
              formControlName="mainCategory"
              [class.valid]="contactUsForm.get('mainCategory').valid && submitted"
              [class.is-invalid]="contactUsForm.get('mainCategory').invalid && submitted"
              >
              <option value="" disabled="true" [selected]="true">Select a Category</option>
              @for (mainCategory of categoryOptions; track mainCategory; let i = $index) {
                <option [value]="mainCategory">
                  {{ mainCategory }}
                </option>
              }
            </select>
            @if (contactUsForm.get('mainCategory').invalid && submitted && contactUsForm.get('mainCategory').errors) {
              <div>
                @if (contactUsForm.get('mainCategory').hasError('required')) {
                  <small class="text-danger">
                    What's going on is required.
                  </small>
                }
              </div>
            }
          </div>

          <div class="row col-md-8">
            <label for="subCategory">Select a Subcategory *</label>
            <select
              class="form-control"
              formControlName="subCategory"
              [class.valid]="contactUsForm.get('subCategory').valid && submitted"
              [class.is-invalid]="contactUsForm.get('subCategory').invalid && submitted"
              >
              <option value="" disabled>Select a Subcategory</option>
              @for (subCategory of subCategoryOptions; track subCategory; let i = $index) {
                <option [value]="subCategory">
                  {{ subCategory }}
                </option>
              }
            </select>
            @if (contactUsForm.get('subCategory').invalid && submitted && contactUsForm.get('subCategory').errors) {
              <div>
                @if (contactUsForm.get('subCategory').hasError('required')) {
                  <small class="text-danger">
                    What's going on is required.
                  </small>
                }
              </div>
            }
          </div>

          <div class="form-group"></div>
          @if (getBrands(contactUsForm.value.country)) {
            <div class="form-group full-width mb-0">
              <label for="">Tell us the brand related to your inquiry *</label>
              <label>Select all that apply</label>
              <div class="form-group full-width mb-0">
                @for (brand of getBrands(contactUsForm.value.country); track brand) {
                  <div class="form-check form-check-inline mb-0">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      [value]="brand"
                      (change)="onBrandChange(brand, $event.target.checked)"
                      />
                      <label class="form-check-label" for="inlineCheckbox">{{ brand }}</label>
                    </div>
                  }
                  @if (submitted && selectedBrands.length === 0) {
                    <div class="mb-4">
                      <small class="text-danger">
                        Brand is required.
                      </small>
                    </div>
                  }
                </div>
              </div>
            }

            <div class="form-group full-width mt-3">
              <label for="">Please provide more details *</label>
              <textarea
                class="form-control"
                formControlName="inquiryText"
                maxlength="1024"
                placeholder="Please provide more details about your inquiry so we an better assist you"
              ></textarea>
              @if (contactUsForm.get('inquiryText').invalid && submitted && contactUsForm.get('inquiryText').errors) {
                <div>
                  @if (contactUsForm.get('inquiryText').hasError('required')) {
                    <small class="text-danger">
                      More details is required.
                    </small>
                  }
                </div>
              }
            </div>

            <div class="form-group full-width">
              <label for="">How would you like to be connected? *</label>
              <div class="form-check form-check-inline mb-0">
                <input class="form-check-input" type="checkbox" formControlName="contactPhone" />
                <label class="form-check-label" for="inlineCheckbox1">Phone</label>
              </div>
              <div class="form-check form-check-inline mb-0">
                <input class="form-check-input" type="checkbox" formControlName="contactEmail" />
                <label class="form-check-label" for="inlineCheckbox2">Email</label>
              </div>
              @if (submitted) {
                <div class="mb-4">
                  <small [hidden]="!contactUsForm.hasError('phnemail')" class="text-danger">
                    How do you like us to connect is required.
                  </small>
                </div>
              }
            </div>

            <div class="form-group">
              <button type="button" class="w-100 mt-1 mt-sm-0 btn btn-primary" (click)="submit()">Submit</button>
            </div>
          </form>
        </div>
